import React from "react"

export const defaultUserAuthContext = {
  name: '',
  isLoggedIn: false
}

const UserAuthContext = React.createContext(defaultUserAuthContext)
export default UserAuthContext
